import { observer } from 'mobx-react';

import { IconName } from '@/common/components/Icon/iconName';
import { useGlobalAccessModalStore } from '@/security/components/GlobalAccessModal/GlobalAccessModalStore';
import { getDataAccessesByType } from '@/security/constants/dataAccess';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';

import GlobalAccessRestrictedDescription from '../GlobalAccessRestrictedDescription/GlobalAccessRestrictedDescription';
import GlobalDataAssessRadio from '../GlobalDataAssessRadio/GlobalDataAssessRadio';

function GlobalAccessDataAccessSelect() {
  const { accessValues, dataAccessValues, isUpdating, setDataAccess, setRecursive, type } = useGlobalAccessModalStore();
  const isPrivateAccess = accessValues[0] === GlobalAccessLevel.Restricted;
  const isRestricted = new Set(accessValues).size === 1 && accessValues[0] === GlobalAccessLevel.Restricted;

  function onChangeDataAccess(nextDataLevel: number) {
    setDataAccess(nextDataLevel);

    setRecursive(true);
  }

  const dataAccessValuesSet = new Set(dataAccessValues);

  if (isRestricted) {
    return (
      <GlobalAccessRestrictedDescription>
        {type === 'product' && (
          <span>All Cut Data, including model and reports is available to company’ employees users.</span>
        )}

        {type === 'project' && (
          <span>
            HP Carbon source data file (.ox2z) is available to company’ employees users. Solution parameters and
            proportions can be viewed in HP Carbon.
          </span>
        )}
      </GlobalAccessRestrictedDescription>
    );
  }

  return (
    <>
      {getDataAccessesByType(type).map((level) => {
        const isChecked = dataAccessValues.includes(level.id);

        return (
          <GlobalDataAssessRadio
            aria-label={level.title}
            key={level.id}
            checked={isChecked}
            description={level.description}
            disabled={isPrivateAccess || isUpdating}
            iconName={level.icon as IconName}
            id={level.id}
            isAmbient={dataAccessValuesSet.size > 1 && isChecked}
            onChange={onChangeDataAccess}
            title={level.title}
          />
        );
      })}
    </>
  );
}

export default observer(GlobalAccessDataAccessSelect);
